import React from "react"
import { useLocation } from "react-router-dom"

const Back = ({ title }) => {
  const location = useLocation()
  const page = location.pathname.split("/")[1]

  return (
    <section className='back'>
      <div className='back-content'>
        <h2>Home / {page}</h2>
        <h1>{title}</h1>
      </div>
    </section>
  )
}

export default Back
